import { render, staticRenderFns } from "./BuddhaNotice.vue?vue&type=template&id=09698620&scoped=true"
import script from "./BuddhaNotice.vue?vue&type=script&lang=js"
export * from "./BuddhaNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09698620",
  null
  
)

export default component.exports